import { jsx as _jsx } from "react/jsx-runtime";
import Close16 from '@carbon/icons-react/es/close/16';
// eslint-disable-next-line no-restricted-imports
import { Tag as AntTag } from 'antd';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
const DefaultTag = ({ color, ...rest })=>/*#__PURE__*/ _jsx(AntTag, {
        color: "default",
        ...rest,
        closeIcon: /*#__PURE__*/ _jsx(Close16, {})
    });
export const Tag = styled(DefaultTag)`
  --tag-border-color: var(--tag-surface-color);

  border-radius: var(--border-radius-default);
  :global(:root[data-new-theme-enabled='true']) & {
    border-radius: var(--border-radius-default) !important;
    height: var(--height-sm) !important;
    padding: var(--padding-xs) var(--padding-01) !important;
    gap: var(--padding-xs);
  }
  margin: var(--spacing-01) 0;
  padding: calc(var(--spacing-02) - 2px) calc(var(--spacing-03) - 2px);
  border: 2px solid var(--tag-border-color);
  background: var(--tag-surface-color);
  color: var(--tag-color);
  font-size: var(--font-size-sm);
  line-height: var(--spacing-05);
  display: inline-flex;
  align-items: center;

  &:focus {
    --tag-border-color: var(--blue-60);
  }

  &:hover {
    opacity: 100%;
    --tag-surface-color: ${({ hoverColor, color })=>hoverColor != null ? `var(--ozone-${hoverColor}-surface)` : `var(--ozone-${color}-surface)`};
    --tag-color: ${({ hoverColor, color })=>hoverColor != null ? `var(--ozone-${hoverColor})` : `var(--ozone-${color})`};
  }

  &.disabled,
  &[disabled] {
    --tag-surface-color: var(--gray-10);
    --tag-color: var(--gray-30);
  }

  ${({ color })=>css`
    --tag-surface-color: var(--ozone-${color}-surface);
    --tag-color: var(--ozone-${color});
  `};

  cursor: ${ifProp('onClick', 'pointer', 'inherit')};

  .ant-tag-close-icon {
    display: flex;
    color: var(--tag-color);

    :global(:root[data-new-theme-enabled='true']) & {
      padding: 0;
      margin-left: 0;
      margin-right: 0;
    }

    &:hover {
      border-radius: 50%;
      color: var(--red-60);
      background-color: var(--red-20);
    }
  }
`;
